const registrationDetails = {
  points: [
    {
      icon: "calendar",
      title: "Date",
      description: "6th July 2024",
    },
    {
      icon: "time",
      title: "Time",
      description: "12:00PM",
    },
    {
      icon: "location",
      title: "Location",
      description: `The Great Hall, Kwame Nkrumah 
        University of Science and Technology, 
        Kumasi, Ashanti Region-Ghana.`,
      link: {
        name: "Get Directions",
        link: "",
      },
    },
    {
      icon: "edit",
      title: "Registration is free",
      description: "Limited seats",
    },
  ],
  about: "",
  host: "",
  benefits: [
    "Gain big network of high profile personalities to assist in you job opportunities and future careers ",
    "Acquire secrets to transform yourself & your community ",
    "Gain Mentoring and Coaching opportunities from YPYC ",
    "Certificate of Participation",
    "Conference Materials ",
    "Snacks (in person)",
    "Etc.",
  ],
  mediaPartners: "",
  mediaPartnersLogos: "",
};

const attendanceOptions = ["In-person", "Virtual via Zoom"];

export { registrationDetails, attendanceOptions };
